<template>
    <span>{{ time }}</span>
</template>

<script>
    export default {
        props: {
            format: {default: 'lll'},
            timezone: {default: null}
        },

        data: () => ({
            interval: null,
            time: 'wait...',
        }),

        created() {
            this.start();
        },

        beforeDestroy() {
            this.stop();
        },

        methods: {
            start() {
                this.interval = setInterval(this.update.bind(this), 1000);
            },
            stop() {
                clearInterval(this.interval);
            },
            update() {
                if(this.timezone === null){
                    this.time = moment().tz(DevSquad.timezone).format(this.format);
                }else{
                    this.time = moment().tz(this.timezone).format(this.format);
                }

            },
        }
    }
</script>
